import { Link } from "react-router-dom";
import { LOGO_URL } from "../lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="main-footer"
      className="relative bg-ink-900 border-t border-ink-500 mt-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 border-b border-ink-500 pb-16">
          {/* Brand */}
          <div className="md:col-span-6">
            <Link to="/" className="inline-flex items-center">
              <img
                src={LOGO_URL}
                alt="DoSoft"
                className="h-16 w-auto object-contain"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </Link>
            <p className="text-ash-300 mt-6 max-w-md leading-relaxed">
              Software Factory. Construimos apps móviles, aplicaciones web y software
              a medida para empresas de cualquier sector. Rápidos, competitivos y
              confiables.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-ash-300 mb-5">
              Plataforma
            </div>
            <ul className="space-y-3">
              <li><Link to="/servicios" className="text-ash-100 hover:text-brand transition-colors">Servicios</Link></li>
              <li><Link to="/soluciones" className="text-ash-100 hover:text-brand transition-colors">Soluciones</Link></li>
              <li><Link to="/casos" className="text-ash-100 hover:text-brand transition-colors">Casos de éxito</Link></li>
              <li><Link to="/cotizador" className="text-ash-100 hover:text-brand transition-colors">Cotizador</Link></li>
              <li><Link to="/contacto" className="text-ash-100 hover:text-brand transition-colors">Contacto</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-ash-300 mb-5">
              Hablemos
            </div>
            <p className="text-ash-300 text-sm leading-relaxed mb-6">
              Toda la conexión con nosotros se hace desde la plataforma. Cotiza o
              déjanos un mensaje y nuestro equipo te contactará.
            </p>
            <Link
              to="/cotizador"
              data-testid="footer-cta-quote"
              className="inline-flex items-center gap-2 bg-brand text-ink-800 font-semibold hover:bg-brand-hover px-5 py-3 uppercase tracking-wider text-xs"
            >
              Cotizar proyecto <ArrowUpRight size={14} strokeWidth={2} />
            </Link>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-10">
          <div className="text-xs text-ash-500 font-mono">
            © {new Date().getFullYear()} DoSoft · Todos los derechos reservados
          </div>
          <div className="flex items-center gap-6 text-xs text-ash-500 uppercase tracking-widest flex-wrap">
            <Link to="/privacidad" className="hover:text-brand transition-colors">Privacidad</Link>
            <Link to="/terminos" className="hover:text-brand transition-colors">Términos</Link>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-brand transition-colors">Acceso Admin</Link>
            <span className="hidden md:inline">Software a Medida · Apps · Producto Digital</span>
          </div>
        </div>
      </div>

      {/* Massive brand watermark */}
      <div className="overflow-hidden border-t border-ink-500">
        <div className="font-display font-black text-[20vw] leading-none text-ink-700 select-none text-center -mb-4 tracking-tighter">
          DOSOFT
        </div>
      </div>
    </footer>
  );
}
